module.exports = __webpack_public_path__ + "static/media/jackbanner.07466424.png";